import { render, staticRenderFns } from "./Draft-pemohon.vue?vue&type=template&id=18df945c"
import script from "./Draft-pemohon.vue?vue&type=script&lang=js"
export * from "./Draft-pemohon.vue?vue&type=script&lang=js"
import style0 from "./Draft-pemohon.vue?vue&type=style&index=0&id=18df945c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports